import { Phase } from '@teetsh/app/src/types/sequences';
import colors from '@teetsh/app/src/colors';
import { getDurationInHoursAndMinutes } from '@teetsh/app/src/utils/time/getDurationInHoursAndMinutes';
import { displayCustomFieldsHtml } from 'containers/CahierJournal/EventModal/ModalBody/Classic/LinkedFichesDePreps/displayCustomFieldsHtml';
import { cleanFontSize, unwrapParagraph } from 'utils/htmlUtils';
import { CustomFieldDefinition } from 'types/customField';
import { TFunction } from 'i18next';

export function fdpPhasesToHtml(
  phases: Phase[],
  customFieldsDefinitions: CustomFieldDefinition[],
  t: TFunction<['cahierJournal' | 'common']>,
) {
  const newFlow = (phases || [])
    .reduce(
      (
        acc,
        { title, flow, dureeInMinute, customFields: phaseCustomFields },
      ) => {
        const customFieldsHtml = displayCustomFieldsHtml(
          phaseCustomFields || [],
          customFieldsDefinitions,
          t,
        );
        const dureeHtml = dureeInMinute
          ? `<strong style="font-size: 0.8rem;color: ${
              colors.gray['400']
            };">${getDurationInHoursAndMinutes(dureeInMinute)}</strong>`
          : '';

        return `${acc}<h5 style="font-size: 0.875rem">${cleanFontSize(
          unwrapParagraph(title),
        )} ${dureeHtml}</h5>
${customFieldsHtml}
<div>${flow}</div><br />`;
      },
      '',
    )
    .replace(/fr-selected-cell/g, ''); // Froala crashes when there are multiple selected cells
  return newFlow;
}
